<template>
  <div>
    <v-container
      fluid
    >
      <v-row
        align="center"
        justify="center"
        class="d-flex-column"
      >
        <DatePicker
          :value="dateRange"
          :isRange="true"
          :rules="{ required: true }"
          :locale="datePickerLocales[$store.getters.lang]"
          class="mt-1"
          outlined
          :max="$utils.getTomorrowDate()"
          @input="dateRange = $event"
          @change="updateData"
        />
      </v-row>
      <v-row>
        <VAutocomplete
          v-model="selectedAccessGroup"
          outlined
          multiple
          :label="$t('clients.accessGroups')"
          itemText="name"
          itemValue="id"
          :items="accessGroups"
          @change="updateData"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DatePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker.vue';
import { mapGetters } from 'vuex';
import _datePickerLocales from '@/locales/date-picker-locales';

export default {
    name: 'WorkOrderExtractToCsv',
    components: {
        DatePicker,
    },
    data() {
        return {
            dateRange: [],
            loading: true,
            accessGroups: [],
            selectedAccessGroup: [],
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'currentMember',
        ]),
        datePickerLocales() {
            return _datePickerLocales;
        },
    },
    created() {
        this.getMemberClients();
    },
    methods: {
        async getMemberClients() {
            const { data: { accessGroups } } = await this.$rq.getMemberAccess(this.currentMember.id);
            this.accessGroups = accessGroups;
        },
        updateData() {
            this.$emit('sendData', { dateRange: this.dateRange, accessGroups: this.selectedAccessGroup });
        },
    },
};
</script>
